import(/* webpackMode: "eager" */ "/app/app/(data-intensive)/project/sprints/[id]/page.tsx");
